import $$ from 'cmn-utils'
import organize from './organize'
import total from './total'


const baseUrl = "/api/grid/";
export default {
    create: (params) => {
        return $$.post(baseUrl + 'create', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    update: (params) => {
        return $$.post(baseUrl + 'update', params)
    },
    getDetail: (params) => {
        return $$.get(baseUrl + 'get-detail', params)
    },
    getDistribute: (params) => {
        return $$.get(baseUrl + 'get-distribute', params)
    },
    organize,total
}